import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class UtilService {

  constructor() { }

  isDevMode() {
    return environment.env === 'dev';
  }

  getConsoleStyle(background: string = "transparent", textColor: string = "black", customStyle?: string) {
    return `font-size:16px;background:${background};color:${textColor};padding:.2em .3em;border-radius:8px;${customStyle}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/util.service.ts